/* ============================================================
   m3x1.js — PDP Dispositivo 3x1 (Mudanza)
   Task 2.2: carousel mechanics + accessible tap-to-zoom.

   Vanilla JS, no jQuery. Self-initializing, scoped per
   [data-m3x1-carousel] instance (multiple per page supported).
   Safe under defer and on DOMContentLoaded (idempotent init).
   ============================================================ */
(function () {
  'use strict';

  // Guard de ejecución única (audit 2026-07-04): si este <script> llegara a
  // emitirse dos veces (p.ej. dos instancias de la sección en el editor), la
  // segunda pasada NO debe duplicar los listeners capture a nivel document
  // (interceptor de garantía, gel guard, observers) — se saldría a mitad.
  if (window.__m3x1Loaded) return;
  window.__m3x1Loaded = true;

  // Build marker (survives minification — string literal). Check in console:
  // window.__m3x1Build  -> confirms WHICH version is actually served/running.
  try { window.__m3x1Build = '2026-07-15-thumb-fade'; } catch (e) {}

  /* ============================================================
     Gel automático = suscripción OBLIGATORIA del 3x1: el cliente NO
     puede QUITARLO ni cambiar su cantidad desde el Rebuy Smart Cart
     (pausa/cancela en su portal de cliente DESPUÉS de la venta).
     OJO: Rebuy NO renderiza el snippet del theme (rebuy-cart-template
     .liquid está MUERTO) — sirve su propia plantilla. Pero su <li> SÍ
     recibe la clase product-<handle> (verificado en vivo por DOM), así
     que inyectamos un <style> global en <head> apuntando al handle del
     gel auto. Esconde la X (remove) + el control de cantidad SOLO en esa
     línea; el precio ($0.00) NO se toca (.rebuy-cart__flyout-item-price,
     aparte). Idempotente (guard por id). 🔴 SCOPE = donde carga m3x1.js
     (el PDP 3x1 = el funnel real ATC->drawer->checkout). Para cobertura
     GLOBAL (carrito abierto en OTRA página) añadir la MISMA regla en
     Rebuy admin -> Smart Cart -> Custom CSS. Si cambia el HANDLE del gel
     auto, actualizar el selector (NO depende del SKU).
     EXCEPCIÓN (Mau 2026-07-02): un gel EXTRA (2º gel, exploit de quitar
     devices y re-agregar) SÍ debe poder quitarse -> el initGelGuard de
     abajo marca esa línea con .m3x1-gel-extra (X visible) o, si es UNA
     línea con qty 2, con .m3x1-gel-multi (stepper visible para bajar a 1).
     El lock por default queda con :not(...). ============ */
  try {
    if (!document.getElementById('m3x1-gel-cart-lock')) {
      var gelLockStyle = document.createElement('style');
      gelLockStyle.id = 'm3x1-gel-cart-lock';
      gelLockStyle.textContent =
        '.rebuy-cart__flyout-item.product-gel-regenerativo-200g-dark-page-product:not(.m3x1-gel-extra) .rebuy-cart__flyout-item-remove,' +
        '.rebuy-cart__flyout-item.product-gel-regenerativo-200g-dark-page-product:not(.m3x1-gel-multi) .rebuy-cart__flyout-item-quantity{display:none !important;}' +
        /* Sin el stepper, el precio del gel caía a la columna del quantity
           (se veía centrado/izquierda en desktop). Alineado a la DERECHA como
           las líneas de los Skindion (Mau 2026-07-05). Inofensivo cuando el
           stepper sí se muestra (estado .m3x1-gel-multi). */
        '.rebuy-cart__flyout-item.product-gel-regenerativo-200g-dark-page-product .rebuy-cart__flyout-item-price{margin-left:auto !important;text-align:right !important;justify-content:flex-end !important;}';
      (document.head || document.documentElement).appendChild(gelLockStyle);
    }
  } catch (e) {
    /* la inyección de estilo NUNCA debe romper el PDP */
  }

  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  /* ============================================================
     Garantía popup — shared module-scope state (Task 4.2).
     The capture-phase interceptor on Rebuy's checkout button and the
     popup itself live in different functions but coordinate through
     these flags (mirrors how the color popup shares m3x1Continuing
     with initAtc — guard + re-trigger, no divergence, no /cart nav).

       m3x1GarantiaProceed         — set true around our re-click so the
                                     capture handler lets that click pass
                                     through to Vue's checkout().
       m3x1GarantiaOffered         — set true once the popup was offered
                                     and resolved (accept/decline/close)
                                     OR the garantía is already in cart;
                                     subsequent checkout clicks pass
                                     straight through (no nag this session).
       m3x1GarantiaInterceptorBound — guards the single document-level
                                     capture listener install. ============================================================ */
  var m3x1GarantiaProceed = false;
  var m3x1GarantiaOffered = false;
  var m3x1GarantiaInterceptorBound = false;

  // true mientras onContinue está agregando gel+devices al carrito. El
  // initGelGuard NO debe correr en esa ventana: el gel se agrega ANTES que
  // los devices (orden del drawer) y el guard lo vería como "gel sin
  // devices" y lo borraría a media venta.
  var m3x1GelAddInFlight = false;

  /* ============================================================
     Shared cart helpers (module scope) — used by BOTH the ATC
     module (Task 2.8) and the 3-color popup (Continuar). Lifted
     out of initAtc so the popup reuses the EXACT same guarded
     drawer-open + refresh behavior (no divergence, no /cart nav).
     ============================================================ */

  /* Tell the theme + Rebuy + pf-garantia the cart changed so every
     listener re-reads it. rebuy:cart.change is the event Rebuy's
     Smart Cart listens to (confirmed in assets/rebuy-events.js); the
     cart:* trio mirrors what pf-garantia-autoadd dispatches. */
  function dispatchCartRefresh() {
    var events = ['rebuy:cart.change', 'cart:refresh', 'cart:build', 'cart:updated'];
    events.forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      } catch (e) {
        /* no-op: a missing CustomEvent ctor must never break the flow */
      }
    });
  }

  /* Open the Rebuy Smart Cart drawer. Layered + guarded so a missing
     API never throws AND we never navigate to /cart. Order:
       1) window.Rebuy.SmartCart.{show|open|toggle}()  — public API
       2) click #cart-icon-bubble ONLY if Rebuy is present (Rebuy
          intercepts that <a href="/cart"> click to open the drawer;
          without Rebuy the click would navigate, so we skip it)
     If neither is available we stop (Rebuy's own "open on add" may
     still react to rebuy:cart.change). We NEVER set location = /cart. */
  function openCartDrawer() {
    var rebuy = window.Rebuy;
    var sc = rebuy && rebuy.SmartCart ? rebuy.SmartCart : null;

    if (sc) {
      var methods = ['show', 'open', 'toggle'];
      for (var i = 0; i < methods.length; i++) {
        if (typeof sc[methods[i]] === 'function') {
          try {
            sc[methods[i]]();
            return true;
          } catch (e) {
            /* try the next known method name */
          }
        }
      }
    }

    // Fallback: trigger Rebuy's bound open path via the cart icon, but
    // ONLY when Rebuy exists (otherwise the <a> would navigate to /cart).
    if (rebuy) {
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        try {
          icon.click();
          return true;
        } catch (e) {
          /* swallow — never navigate as a side effect */
        }
      }
    }

    return false;
  }

  function initCarousel(root) {
    if (!root || root.dataset.m3x1Init === '1') return;
    root.dataset.m3x1Init = '1';

    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-carousel-slide]')
    );
    var thumbs = Array.prototype.slice.call(
      root.querySelectorAll('[data-carousel-thumb]')
    );

    if (!track || slides.length === 0) return;

    var activeIndex = 0;
    var isScrollingProgrammatically = false;
    var scrollSettleTimer = null;

    /* ---- Thumbnail active state -------------------------------- */
    function setActive(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      if (index === activeIndex) return;
      activeIndex = index;

      thumbs.forEach(function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        if (on) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    /* ---- Scroll a slide into view in the snap track ----------- */
    /* Start-aligned (Mau 2026-07-05): slides use `scroll-snap-align: start`,
       así que el target = offsetLeft del slide (su borde izquierdo pega al
       borde del scrollport). Clamp al rango real de scroll. El CSS usa
       `scroll-snap-stop: always` para que un swipe = UNA imagen; eso también
       bloquearía este salto multi-slide por thumbnail, así que apagamos el
       snap del track (scrollSnapType='none') DURANTE el scroll suave y lo
       restauramos al asentar (re-snap al target, ya alineado, sin tirón). */
    function goToSlide(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      var slide = slides[index];
      if (!slide) return;

      var left = slide.offsetLeft;
      var maxLeft = track.scrollWidth - track.clientWidth;
      if (left < 0) left = 0;
      if (left > maxLeft) left = maxLeft;

      isScrollingProgrammatically = true;
      // Deja pasar el salto multi-slide sin que `scroll-snap-stop: always` lo
      // frene un snap point corto.
      track.style.scrollSnapType = 'none';
      // Horizontal scroll only; avoid vertical page jump.
      track.scrollTo({ left: left, behavior: 'smooth' });
      setActive(index);

      window.clearTimeout(scrollSettleTimer);
      scrollSettleTimer = window.setTimeout(function () {
        // Restaura el snap del CSS (x mandatory) — el scroll ya asentó en el target.
        track.style.scrollSnapType = '';
        isScrollingProgrammatically = false;
      }, 400);
    }

    /* ---- Derive active slide from scroll position ------------- */
    function syncActiveFromScroll() {
      if (isScrollingProgrammatically) return;
      var center = track.scrollLeft + track.clientWidth / 2;
      var nearest = 0;
      var nearestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var slideCenter = slides[i].offsetLeft + slides[i].offsetWidth / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = i;
        }
      }
      setActive(nearest);
    }

    var rafPending = false;
    track.addEventListener(
      'scroll',
      function () {
        if (rafPending) return;
        rafPending = true;
        window.requestAnimationFrame(function () {
          rafPending = false;
          syncActiveFromScroll();
        });
      },
      { passive: true }
    );

    /* ---- Thumbnails drive the track --------------------------- */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-slide-index'), 10);
        if (!isNaN(idx)) goToSlide(idx);
      });
    });

    /* ---- Keyboard nav on the track ---------------------------- */
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goToSlide(activeIndex + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goToSlide(activeIndex - 1);
      }
    });

    /* ---- Degradado + asomo en la tira de miniaturas (Mau 2026-07-15) -------
       La tira se desvanece en el borde que tiene mas miniaturas ocultas para
       dejar claro que hay MAS fotos a las que deslizar (reseña, gel, garantia,
       incluye). El fade lo hace mask-image via clase (ver m3x1.css); aqui solo
       elegimos el lado segun scrollLeft. Sin overflow (pocas fotos) no rinde nada. */
    var thumbsEl = root.querySelector('[data-carousel-thumbs]');
    function syncThumbFades() {
      if (!thumbsEl) return;
      var max = thumbsEl.scrollWidth - thumbsEl.clientWidth;
      var canScroll = max > 4;
      var atStart = thumbsEl.scrollLeft <= 2;
      var atEnd = thumbsEl.scrollLeft >= max - 2;
      thumbsEl.classList.toggle('is-fade-right', canScroll && atStart);
      thumbsEl.classList.toggle('is-fade-left', canScroll && atEnd);
      thumbsEl.classList.toggle('is-fade-both', canScroll && !atStart && !atEnd);
    }
    if (thumbsEl) {
      var thumbFadeRaf = false;
      thumbsEl.addEventListener(
        'scroll',
        function () {
          if (thumbFadeRaf) return;
          thumbFadeRaf = true;
          window.requestAnimationFrame(function () {
            thumbFadeRaf = false;
            syncThumbFades();
          });
        },
        { passive: true }
      );
      window.addEventListener('resize', syncThumbFades);
      syncThumbFades();
    }

    initZoom(root, slides);
  }

  /* ============================================================
     Accessible zoom modal
     ============================================================ */
  function initZoom(root, slides) {
    var modal = root.querySelector('[data-zoom-modal]');
    if (!modal) return;

    var dialog = modal.querySelector('[data-zoom-dialog]');
    var img = modal.querySelector('[data-zoom-img]');
    var closeBtn = modal.querySelector('[data-zoom-close]');
    var overlay = modal.querySelector('[data-zoom-overlay]');
    var triggers = Array.prototype.slice.call(
      root.querySelectorAll('[data-zoom-trigger]')
    );

    if (!dialog || !img || triggers.length === 0) return;

    var lastFocused = null;
    var keydownHandler = null;
    // Timer del cierre en transición: si se re-abre dentro de los 200ms del
    // close(), hay que cancelarlo o el timer viejo esconde el modal recién
    // abierto (race del audit 2026-07-04).
    var closeTimer = null;

    function open(trigger) {
      var src = trigger.getAttribute('data-zoom-src');
      var alt = trigger.getAttribute('data-zoom-alt') || '';
      if (!src) return;

      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      lastFocused = trigger;
      img.setAttribute('src', src);
      img.setAttribute('alt', alt);

      modal.hidden = false;
      // Force reflow so the CSS transition runs from the open state.
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.documentElement.classList.add('m3x1-zoom-lock');

      keydownHandler = onKeydown;
      document.addEventListener('keydown', keydownHandler, true);

      // Move focus into the dialog (close button is a safe first stop).
      (closeBtn || dialog).focus();
    }

    function close() {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('m3x1-zoom-lock');

      if (keydownHandler) {
        document.removeEventListener('keydown', keydownHandler, true);
        keydownHandler = null;
      }

      // Wait out the transition before hiding + clearing the src.
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        modal.hidden = true;
        img.setAttribute('src', '');
        img.setAttribute('alt', '');
      }, 200);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
      lastFocused = null;
    }

    function trapFocus(e) {
      var focusables = Array.prototype.slice
        .call(dialog.querySelectorAll(FOCUSABLE))
        .filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      if (focusables.length === 0) {
        e.preventDefault();
        dialog.focus();
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || !dialog.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (active === last || !dialog.contains(active)) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open(trigger);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
  }

  /* ============================================================
     Boot — find every carousel instance on the page.
     ============================================================ */
  function boot() {
    var roots = document.querySelectorAll('[data-m3x1-carousel]');
    Array.prototype.forEach.call(roots, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    // Script loaded after DOM is ready (e.g. defer) — boot immediately.
    boot();
  }

  // Re-init when re-rendered by the Theme Editor / Section Rendering API.
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    var roots = target.querySelectorAll
      ? target.querySelectorAll('[data-m3x1-carousel]')
      : [];
    Array.prototype.forEach.call(roots, initCarousel);
  });

  /* ============================================================
     ATC module (Task 2.8) — AJAX add-to-cart + open cart drawer.

     🔴 INVARIANT (protocolofacial): the form keeps
     data-type="add-to-cart-form". pf-garantia-autoadd.liquid is a
     PASSIVE capture-phase submit listener that schedules its own
     Garantía add 700ms later. We coexist: capture (pf-garantia) runs
     first, then this BUBBLE-phase handler runs. We call
     e.preventDefault() (stop navigation) but NEVER e.stopPropagation()
     (that would kill pf-garantia). We do not touch its flow.

     On success we add via /cart/add.js, dispatch the cart-refresh
     events the theme + Rebuy + pf-garantia use, then open the Rebuy
     Smart Cart drawer. Every drawer-open path is guarded so a missing
     API never throws and we NEVER fall back to navigating to /cart.
     ⚠️ NEEDS MAU'S BROWSER to confirm the exact Rebuy open call;
     Task 4.1 will harden the full cart-drawer-only behavior.
     ============================================================ */
  function initAtc(form) {
    if (!form || form.dataset.m3x1AtcInit === '1') return;
    form.dataset.m3x1AtcInit = '1';

    var btn = form.querySelector('[data-m3x1-atc-btn]');
    var label = form.querySelector('[data-m3x1-atc-label]');
    var errorEl = form.querySelector('[data-m3x1-atc-error]');
    var submitting = false;

    /* The 3-color popup wired to THIS form (data-popup-form == form.id).
       When present, the ATC button OPENS it instead of adding 1; the popup's
       Continuar handler does the multi-add. When absent (e.g. < 2 colors
       resolved → popup not rendered), the button degrades to AJAX add-1 so
       it still works as progressive enhancement (native submit also adds 1). */
    function getPopup() {
      // 🔴 GOTCHA (NO cambiar a form.id): el <form> contiene
      // <input name="id"> (el variant id). Un control con name="id" SOMBREA la
      // propiedad nativa form.id → form.id devuelve ESE input (un objeto), no el
      // string del atributo id. Coaccionado a string daba
      // [data-popup-form="[object HTMLInputElement]"] → 0 matches → el ATC caía
      // a fallbackAddOne() (agregaba 1 solo Skindion). getAttribute('id') lee el
      // atributo real sin importar el control sombreador. (Verificado en runtime.)
      var formId = form.getAttribute('id');
      if (!formId) return null;
      return document.querySelector(
        '[data-m3x1-popup][data-popup-form="' + formId + '"]'
      );
    }

    function setLoading(on) {
      if (!btn) return;
      if (on) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');
        if (label) {
          label.textContent =
            btn.getAttribute('data-label-loading') || 'Agregando…';
        }
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
        if (label) {
          label.textContent =
            btn.getAttribute('data-label-default') || label.textContent;
        }
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent =
        msg || 'No se pudo agregar al carrito. Intenta de nuevo.';
    }

    function clearError() {
      if (errorEl) errorEl.textContent = '';
    }

    /* Fallback AJAX add-1 (only when no popup is wired to this form). Mirrors
       the original Task 2.8 behavior: add the principal variant + any Set Anual
       property, refresh, open drawer, never navigate. */
    function fallbackAddOne() {
      if (submitting) return;
      submitting = true;
      clearError();
      setLoading(true);

      // Set Anual opt-in (Sesion 11): if checked, the device + the REAL Set Anual
      // product ($1,495, variant 48905044852971) go in one atomic JSON add, with
      // the "mes 12" property on the Set line (mirror of onContinue). Otherwise a
      // plain FormData add of the single principal variant. (This path only fires
      // when no color popup is wired — degenerate for the 3x1 — but it must still
      // charge the Set correctly if the box is checked.)
      var setAnual = form.querySelector('[data-m3x1-setanual-input]');
      var body, headers;
      if (setAnual && setAnual.checked) {
        var idInput = form.querySelector('[name="id"]');
        var principalId = idInput ? idInput.value : null;
        var setItem = { id: 48905044852971, quantity: 1 };
        if (setAnual.name) {
          var m = setAnual.name.match(/^properties\[(.+)\]$/);
          var key = m ? m[1] : setAnual.name;
          var props = {};
          props[key] = setAnual.value;
          setItem.properties = props;
        }
        // Sin el id del device NO se agrega solo el Set Anual ($1,495 sin
        // dispositivo = orden inválida). Bail con error visible (audit 2026-07-04).
        if (!principalId) {
          setLoading(false);
          submitting = false;
          showError();
          return;
        }
        var items = [{ id: principalId, quantity: 1 }, setItem];
        body = JSON.stringify({ items: items });
        headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      } else {
        body = new FormData(form);
        headers = { Accept: 'application/json' };
      }

      window
        .fetch('/cart/add.js', {
          method: 'POST',
          headers: headers,
          body: body
        })
        .then(function (res) {
          if (!res.ok) {
            return res
              .json()
              .catch(function () {
                return null;
              })
              .then(function (body) {
                var msg = body && body.description ? body.description : null;
                throw new Error(msg || 'cart_add_failed');
              });
          }
          return res.json();
        })
        .then(function () {
          dispatchCartRefresh();
          openCartDrawer();
          setLoading(false);
          submitting = false;
        })
        .catch(function (err) {
          setLoading(false);
          submitting = false;
          showError(
            err && err.message && err.message !== 'cart_add_failed'
              ? err.message
              : null
          );
          // Never navigate away on error.
        });
    }

    // ── ATC interaction — driven by the button CLICK, not a form submit ─────
    // 🔴 Rebuy Smart Cart intercepts add-to-cart at DOCUMENT-CAPTURE (it does
    // its own 1-item add + auto-opens its drawer, with stopImmediatePropagation,
    // BEFORE any of our handlers). A bubble-phase stopPropagation was too late
    // (the bug: drawer covered the color popup). The robust fix: the ATC button
    // is type="button" with NO name="add", so Rebuy never recognizes it as an
    // add-to-cart trigger and stays out. We open the color popup from the CLICK
    // (no form submit fires on the real click). The {% form %} stays only so the
    // popup's Continuar can dispatch a SYNTHETIC submit to fire pf-garantia.
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var popup = getPopup();
        if (popup && popup.m3x1Open) {
          popup.m3x1Open(btn);
          return;
        }
        // No color popup wired (e.g. < 2 colors resolved) -> AJAX add the
        // principal variant ourselves (Rebuy is not involved).
        fallbackAddOne();
      });
    }

    // Synthetic submit ONLY. The popup's Continuar dispatches a `submit` on this
    // form to trigger pf-garantia's CAPTURE-phase listener (the real multi-add
    // already happened in the popup). Since the ATC button is type="button", a
    // real click never submits, so this handler only ever sees that synthetic
    // submit: cancel any default and no-op. pf-garantia's capture listener has
    // already run by the time this bubble handler fires. NUNCA stopPropagation.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });
  }

  function bootAtc() {
    var forms = document.querySelectorAll('.m3x1__atc-form');
    Array.prototype.forEach.call(forms, initAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAtc);
  } else {
    bootAtc();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    var forms = target.querySelectorAll
      ? target.querySelectorAll('.m3x1__atc-form')
      : [];
    Array.prototype.forEach.call(forms, initAtc);
  });

  /* ============================================================
     3-color popup (Mudanza 3x1) — Skindion 1 is FIXED (the PDP's
     current color); the shopper only picks the color of Skindion 2
     and Skindion 3. Then add the 3 device variants + open the drawer.

     Accessible modal: MIRRORS the zoom modal pattern (role="dialog"
     aria-modal, focus-trap reusing FOCUSABLE, ESC, overlay-click,
     scroll-lock, restore-focus to the ATC button).

     Continuar flow (the delicate part):
       a. resolve 3 variant ids: Skindion 1 = the linked ATC form's
          hidden name="id" ([data-m3x1-variant-id]); Skindion 2 & 3 =
          the two editable popup rows (m3x1-color-row-2 / -3).
       b. read the Set Anual checkbox from the linked form; if checked,
          attach properties[...] to the PRINCIPAL item (Skindion 1)
       c. POST /cart/add.js with an items[] array (JSON multi-add)
       d. 🔴 trigger pf-garantia WITHOUT editing it and WITHOUT navigating:
          set form.dataset.m3x1Continuing='1' then dispatch a `submit`
          event on the form. pf-garantia's CAPTURE listener catches it
          (checks data-type="add-to-cart-form") and schedules the garantía
          add. A *dispatched* submit does NOT navigate (only real /
          requestSubmit() submits navigate), and the form's own bubble
          handler sees the guard flag and does nothing. NO stopPropagation
          anywhere (it would kill pf-garantia's capture listener).
       e. dispatch cart-refresh, open the Rebuy drawer (shared
          openCartDrawer), close the popup. Loading + graceful error.

     The $0-for-2 is a Mau backend "compra 1 llévate 2" automatic discount
     (BXGY); this module only ADDS the 3 chosen variants — the discount
     zeroes 2 of them in the cart/checkout.
     ============================================================ */
  function initPopup(root) {
    if (!root || root.dataset.m3x1PopupInit === '1') return;
    root.dataset.m3x1PopupInit = '1';

    var dialog = root.querySelector('[data-m3x1-popup-dialog]');
    var overlay = root.querySelector('[data-m3x1-popup-overlay]');
    var closeBtn = root.querySelector('[data-m3x1-popup-close]');
    var continueBtn = root.querySelector('[data-m3x1-popup-continue]');
    var continueLabel = root.querySelector('[data-m3x1-popup-continue-label]');
    var errorEl = root.querySelector('[data-m3x1-popup-error]');
    var formId = root.getAttribute('data-popup-form');

    if (!dialog || !continueBtn) return;

    var lastFocused = null;
    var keydownHandler = null;
    var submitting = false;

    function getForm() {
      return formId ? document.getElementById(formId) : null;
    }

    function setLoading(on) {
      if (on) {
        continueBtn.setAttribute('disabled', 'disabled');
        continueBtn.setAttribute('aria-busy', 'true');
        continueBtn.classList.add('is-loading');
        if (continueLabel) {
          continueLabel.textContent =
            continueBtn.getAttribute('data-label-loading') || 'Agregando…';
        }
      } else {
        continueBtn.removeAttribute('disabled');
        continueBtn.removeAttribute('aria-busy');
        continueBtn.classList.remove('is-loading');
        if (continueLabel) {
          continueLabel.textContent =
            continueBtn.getAttribute('data-label-default') || continueLabel.textContent;
        }
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent =
        msg || 'No se pudo agregar al carrito. Intenta de nuevo.';
    }

    function clearError() {
      if (errorEl) errorEl.textContent = '';
    }

    /* ---- Open / close (mirror of the zoom modal) -------------- */
    // Timer del cierre en transición (race del audit 2026-07-04): sin esto,
    // re-abrir dentro de los 200ms del close() se tragaba el tap del ATC.
    var closeTimer = null;
    function open(trigger) {
      // Abierto DE VERDAD (sin cierre en transición) -> no re-abrir.
      if (!root.hidden && !closeTimer) return;
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      lastFocused = trigger || document.activeElement;
      clearError();

      root.hidden = false;
      // Force reflow so the CSS transition runs from the open state.
      void root.offsetWidth;
      root.classList.add('is-open');
      document.documentElement.classList.add('m3x1-zoom-lock');

      keydownHandler = onKeydown;
      document.addEventListener('keydown', keydownHandler, true);

      // Move focus into the dialog (close button is a safe first stop).
      (closeBtn || dialog).focus();
    }

    function close() {
      if (root.hidden || closeTimer) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('m3x1-zoom-lock');

      if (keydownHandler) {
        document.removeEventListener('keydown', keydownHandler, true);
        keydownHandler = null;
      }

      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        root.hidden = true;
      }, 200);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
      lastFocused = null;
    }

    function trapFocus(e) {
      var focusables = Array.prototype.slice
        .call(dialog.querySelectorAll(FOCUSABLE))
        .filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      if (focusables.length === 0) {
        e.preventDefault();
        dialog.focus();
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || !dialog.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (active === last || !dialog.contains(active)) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    }

    /* ---- Resolve the 3 device variant ids --------------------- */
    /* Skindion 1 is FIXED = the PDP's current color: its variant id comes from
       the linked ATC form's hidden name="id" ([data-m3x1-variant-id]), NOT from
       a popup row. Skindion 2 and 3 come from the two editable popup rows
       (m3x1-color-row-2 / -3). Returns [s1, s2, s3] or null if any is invalid. */
    function selectedVariantIds() {
      var form = getForm();
      // Skindion 1 — the PDP color, read straight off the ATC form hidden input.
      var s1El = form ? form.querySelector('[data-m3x1-variant-id]') : null;
      var s1 = s1El ? parseInt(s1El.value, 10) : NaN;
      if (isNaN(s1)) return null;

      var ids = [s1];
      for (var row = 2; row <= 3; row++) {
        var checked = root.querySelector(
          'input[name="m3x1-color-row-' + row + '"]:checked'
        );
        // Defensive (I-1): out-of-stock colors render as DISABLED radios that can
        // never be default-checked. But if a tampered/edge selection somehow lands
        // on a disabled (unavailable) radio, ignore it — never send an OOS variant
        // (it would 422 the whole items[] batch). A row with no VALID selection
        // returns null so onContinue() takes the graceful error path (no throw).
        if (!checked || !checked.value || checked.disabled) return null;
        var id = parseInt(checked.value, 10);
        if (isNaN(id)) return null;
        ids.push(id);
      }
      return ids;
    }

    // Replica pf-garantia para el flujo 3x1 SIN submit sintético. Disparar un
    // `submit` en el form hacía que el product-form del theme/Rebuy agregara OTRA
    // VEZ la variante principal (name="id") = un 4º Skindion (bug Mau 2026-06-21).
    // pf-garantia (listener de submit) solo agrega la garantía, pero el OTRO
    // listener de submit metía el device extra. Solución: NO dispatch submit;
    // agregamos la garantía aquí, directo, solo para ?ref=protocolofacial
    // (sessionStorage pf_garantia), con de-dup vía /cart.js. No-bloqueante.
    function maybeAddPfGarantia() {
      var isPF = false;
      try {
        isPF = window.sessionStorage.getItem('pf_garantia') === '1';
      } catch (e) {
        /* sessionStorage bloqueado -> no PF */
      }
      if (!isPF) return Promise.resolve();
      var GAR = 46991019933931;
      return window
        .fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var has = (cart.items || []).some(function (i) {
            return i.variant_id === GAR;
          });
          if (has) return null; // ya está (de-dup): no duplicar la garantía
          return window.fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: GAR, quantity: 1 }] })
          });
        })
        .catch(function () {
          return null; // la garantía PF nunca debe romper la venta 3x1
        });
    }

    /* ---- Continuar: multi-add + pf-garantia + drawer ---------- */
    function onContinue() {
      if (submitting) return;
      var form = getForm();
      var ids = selectedVariantIds();
      if (!ids) {
        showError('Elige un color para cada Skindion.');
        return;
      }

      submitting = true;
      m3x1GelAddInFlight = true;
      clearError();
      setLoading(true);

      // (b) Set Anual opt-in (Sesion 11, Mau): the checkbox is no longer a free
      // intent flag — when checked the customer is BUYING the real "Set Anual de
      // Geles" product (variant 48905044852971, $1,495). The product being IN THE
      // ORDER is the clean signal for Rebuy (Caso 3/4 -> never re-offer P1a/P1b)
      // and Skio (defer next gel charge to +12mo). The line-item property
      // "Set Anual de Geles 3x2" (the human "mes 12" marker) moves ONTO the Set
      // line; the principal device stays clean. Inventory is untracked, so the
      // Set never OOS-fails -> safe to ride the atomic devices add (Mau's call:
      // it's a paid item the customer chose; an error should surface + retry, not
      // silently drop $1,495).
      var principal = { id: ids[0], quantity: 1 };
      var setAnualItem = null;
      if (form) {
        var setAnual = form.querySelector('[data-m3x1-setanual-input]');
        if (setAnual && setAnual.checked) {
          setAnualItem = { id: 48905044852971, quantity: 1 };
          if (setAnual.name) {
            // name is "properties[Set Anual de Geles 3x2]" -> extract the key.
            var m = setAnual.name.match(/^properties\[(.+)\]$/);
            var key = m ? m[1] : setAnual.name;
            var props = {};
            props[key] = setAnual.value;
            setAnualItem.properties = props;
          }
        }
      }

      // (c) HARDENING (Sesion 10) + ORDEN DEL CARRITO (Mau 2026-06-24): the 3
      // devices are the SALE; the baked gel is a SEPARATE, non-blocking add. A
      // single /cart/add.js items[] is ATOMIC, so bundling the gel would let ANY
      // gel failure (OOS, selling_plan/Skio error) reject the WHOLE add and tumble
      // the 3x1 sale. Rebuy renders the Smart Cart NEWEST-FIRST, so to show the gel
      // at the BOTTOM (Skindions on top) we add the GEL FIRST (oldest) and the
      // devices AFTER (newest -> top). The gel still NEVER blocks the sale: its
      // failure is swallowed, and if the DEVICES add fails afterward we remove the
      // orphan gel so a retry never leaves/duplicates a lone gel in the cart.
      // The Set Anual (if chosen) rides the atomic devices add — paid + untracked,
      // so it won't be the thing that fails (Sesion 11).
      var devices = [
        principal,
        { id: ids[1], quantity: 1 },
        { id: ids[2], quantity: 1 }
      ];
      if (setAnualItem) devices.push(setAnualItem);

      // The baked subscription gel (ALWAYS in the 3x1 flow — not opt-in). The
      // selling_plan triggers Skio's plan (100% off first cycle -> enters at $0).
      // The leading-underscore _m3x1_gel property is hidden in cart/checkout and
      // lets us recognize the gel later (disclosure / de-dupe).
      var gelItem = {
        id: 46874616955115,
        quantity: 1,
        selling_plan: 11511857387,
        // _m3x1_gel (underscore) = hidden flag para reconocer/de-dup el gel.
        // 'Renovación' (sin underscore) = propiedad VISIBLE: Rebuy la pinta bajo
        // el título en el carrito Y aparece en el checkout (refuerza el "Subtotal
        // recurrente" nativo). Aclara los 2 datos que pidió Mau: 1er cobro a 90
        // días + $549 c/90 (no $600). El precio de la variante ya está en $549.
        properties: {
          _m3x1_gel: 'auto',
          'Renovación': '1er cobro y envío a los 90 días, $549 MXN c/90 días (pausa o cancela cuando quieras)'
        }
      };

      // gelLineKey is captured when the gel add SUCCEEDS; used to remove the orphan
      // gel if the devices (the SALE) fail afterward. gelLineQty guarda la qty de
      // la LÍNEA devuelta: /cart/add.js MERGEA con un gel ya existente (compra 3x1
      // previa en el mismo carrito), así que el cleanup DECREMENTA (qty-1) en vez
      // de poner 0 — poner 0 borraba también el gel legítimo (audit 2026-07-04).
      var gelLineKey = null;
      var gelLineQty = 0;

      window
        // (d) GEL FIRST (oldest -> bottom of Rebuy's newest-first cart). Its own
        // add, failure SWALLOWED: the gel must NEVER block the 3x1 sale.
        .fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [gelItem] })
        })
        .then(function (res) {
          if (!res.ok) throw new Error('gel_add_failed');
          return res.json();
        })
        .then(function (body) {
          if (body && body.items && body.items[0]) {
            gelLineKey = body.items[0].key;
            gelLineQty = Number(body.items[0].quantity) || 1;
          }
        })
        .catch(function (gelErr) {
          gelLineKey = null;
          gelLineQty = 0;
          try {
            if (window.console && window.console.warn) {
              window.console.warn(
                'm3x1: el gel automatico no se pudo agregar; la venta 3x1 se conserva.',
                gelErr && gelErr.message
              );
            }
          } catch (e) {
            /* console missing must never break the flow */
          }
          return null;
        })
        .then(function () {
          // (e) DEVICES = THE SALE (atomic, must succeed). Added AFTER the gel so
          // they render ON TOP. A failure here rejects -> the .catch below removes
          // the orphan gel and keeps the popup open to retry.
          return window
            .fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ items: devices })
            })
            .then(function (res) {
              if (!res.ok) {
                return res
                  .json()
                  .catch(function () {
                    return null;
                  })
                  .then(function (body) {
                    var msg = body && body.description ? body.description : null;
                    throw new Error(msg || 'cart_add_failed');
                  });
              }
              return res.json();
            });
        })
        .then(function () {
          // (f) protocolofacial: agrega la Garantía GRATIS directamente, sin
          // submit sintético (ese submit hacía que el theme/Rebuy reagregara el
          // device principal = 4º Skindion). Solo corre para ?ref=protocolofacial
          // y es no-bloqueante (ver maybeAddPfGarantia).
          return maybeAddPfGarantia();
        })
        .then(function () {
          // (g) Refresh the cart, open the drawer, close the popup.
          m3x1GelAddInFlight = false;
          dispatchCartRefresh();
          openCartDrawer();
          setLoading(false);
          submitting = false;
          close();
        })
        .catch(function (err) {
          // Only a DEVICES add failure reaches here (the gel add swallows its own
          // error above). Remove the orphan gel (if it was added) so a retry never
          // leaves/duplicates a lone gel, then keep the popup open to retry. Never
          // navigate away on error.
          var finish = function () {
            m3x1GelAddInFlight = false;
            setLoading(false);
            submitting = false;
            showError(
              err && err.message && err.message !== 'cart_add_failed'
                ? err.message
                : null
            );
          };
          if (gelLineKey) {
            window
              .fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                // Decrementa SOLO el gel de este intento: si la línea venía
                // mergeada con un gel previo legítimo, ese sobrevive.
                body: JSON.stringify({
                  id: gelLineKey,
                  quantity: Math.max(gelLineQty - 1, 0)
                })
              })
              .then(function () {
                dispatchCartRefresh();
              })
              .catch(function () {
                /* cleanup best-effort: never block the retry path */
              })
              .then(finish);
          } else {
            finish();
          }
        });
    }

    /* ---- Dynamic row thumbnail -------------------------------- */
    /* Each editable row (Skindion 2 / 3) shows the device photo of the COLOR
       selected in that row. Both color photos are rendered in the row's
       [data-thumb-handle] images; we toggle .is-active to the one whose handle
       matches the row's checked radio. Pure display swap (no network). */
    function syncRowThumb(row) {
      if (!row) return;
      var checked = row.querySelector('.m3x1-popup__swatch-input:checked');
      var handle = checked ? checked.getAttribute('data-color-handle') : null;
      var imgs = row.querySelectorAll('[data-thumb-handle]');
      Array.prototype.forEach.call(imgs, function (img) {
        img.classList.toggle(
          'is-active',
          handle != null && img.getAttribute('data-thumb-handle') === handle
        );
      });
    }

    var rows = Array.prototype.slice.call(
      root.querySelectorAll('.m3x1-popup__row')
    );
    rows.forEach(function (row) {
      row.addEventListener('change', function (e) {
        if (e.target && e.target.classList.contains('m3x1-popup__swatch-input')) {
          syncRowThumb(row);
        }
      });
      // Reflect the server-rendered default-checked color on init (and any
      // bfcache-restored selection) so the thumbnail matches the radio.
      syncRowThumb(row);
    });

    // Expose open() so the ATC submit handler can trigger it by reference.
    root.m3x1Open = open;

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    continueBtn.addEventListener('click', onContinue);
  }

  function bootPopup() {
    /* Neutralizar el popup viejo "Skindion Days" (<popup-gift-device>): vive en el
       grupo global "overlays" y se dispara con device-en-carrito, chocando con
       nuestro popup de color en el flujo 3x1. m3x1.js SOLO corre en el PDP 3x1, así
       que removerlo del DOM aquí lo desactiva solo en el 3x1 (el resto del theme lo
       conserva; portable al launch scoped por template). Idempotente. */
    var oldGiftPopup = document.querySelector('popup-gift-device');
    if (oldGiftPopup) { oldGiftPopup.remove(); }
    var roots = document.querySelectorAll('[data-m3x1-popup]');
    Array.prototype.forEach.call(roots, initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPopup);
  } else {
    bootPopup();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    var roots = target.querySelectorAll
      ? target.querySelectorAll('[data-m3x1-popup]')
      : [];
    Array.prototype.forEach.call(roots, initPopup);
  });

  /* ============================================================
     Set Anual toggle (Task 2.7) — shows/hides the confirmation
     line when the "Set Anual de Geles 3x2" checkbox changes.

     The checkbox itself is a real name="properties[...]" input
     inside the ATC <form>, so its value rides the existing
     /cart/add.js FormData with NO JS help. This module is ONLY
     the visual microcopy toggle. No price math — the real 3x2 +
     mes 3 → mes 12 deferral is Skio backend config owned by Mau
     (see the stub in snippets/m3x1-set-anual.liquid).
     ============================================================ */
  function initSetAnual(root) {
    if (!root || root.dataset.m3x1SetanualInit === '1') return;

    var input = root.querySelector('[data-m3x1-setanual-input]');
    var confirm = root.querySelector('[data-m3x1-setanual-confirm]');
    if (!input || !confirm) return;

    root.dataset.m3x1SetanualInit = '1';

    function sync() {
      if (input.checked) {
        confirm.hidden = false;
        confirm.classList.add('is-active');
      } else {
        confirm.hidden = true;
        confirm.classList.remove('is-active');
      }
    }

    input.addEventListener('change', sync);
    // Reflect any pre-checked state (e.g. bfcache restore) on init.
    sync();
  }

  function bootSetAnual() {
    var roots = document.querySelectorAll('[data-m3x1-setanual]');
    Array.prototype.forEach.call(roots, initSetAnual);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSetAnual);
  } else {
    bootSetAnual();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    var roots = target.querySelectorAll
      ? target.querySelectorAll('[data-m3x1-setanual]')
      : [];
    Array.prototype.forEach.call(roots, initSetAnual);
  });

  /* ============================================================
     Sticky CTA bar (Task 2.9) — fixed price + button that appears
     once the hero CTA scrolls above the viewport, and hides when
     it scrolls back into view.

     🔴 REUSE (no divergence): the sticky button is type="button",
     lives OUTSIDE the {% form %}, and simply PROXIES a .click() to
     the real ATC submit button [data-m3x1-atc-btn]. That fires the
     form's submit -> initAtc -> 3-color popup (or add-1 fallback)
     -> multi-add + pf-garantia + drawer. Byte-for-byte identical to
     tapping the hero CTA. We add NO submit listener and NEVER call
     stopPropagation here — only a click listener on the sticky btn.

     Visibility uses an IntersectionObserver on the hero ATC form:
     show only when the CTA has scrolled ABOVE the top of the
     viewport (!isIntersecting && boundingClientRect.top < 0) — NOT
     merely because it is below the fold on load. Toggle = remove the
     `hidden` attribute (+ .is-visible for the CSS transition, like
     the modals toggle .is-open). If IntersectionObserver is missing
     we leave the bar hidden (graceful — never crash old browsers).
     ============================================================ */
  function initSticky(root) {
    if (!root || root.dataset.m3x1StickyInit === '1') return;

    // Resolve the hero ATC form + its real submit button (mirrors the popup's
    // data-popup-form lookup). No form or no button -> no-op (never throw).
    var formId = root.getAttribute('data-sticky-form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;
    var realAtcBtn = form.querySelector('[data-m3x1-atc-btn]');
    if (!realAtcBtn) return;

    var stickyBtn = root.querySelector('[data-m3x1-sticky-btn]');
    if (!stickyBtn) return;

    root.dataset.m3x1StickyInit = '1';

    // Timer del hide en transición (race del audit 2026-07-04): un flick
    // rápido de vuelta dentro de los 220ms dejaba la barra oculta el resto
    // del scroll (show() early-return con el timer viejo aún pendiente).
    var hideTimer = null;

    // La burbuja de Chatwoot se sube sobre el sticky vía CSS: al mostrar el sticky
    // ponemos body.m3x1-sticky-on y m3x1.css sube su `bottom` (baja al quitarla).
    function show() {
      if (hideTimer) {
        window.clearTimeout(hideTimer);
        hideTimer = null;
      }
      if (root.classList.contains('is-visible')) return;
      root.hidden = false;
      // Force reflow so the slide-up transition runs from the hidden state.
      void root.offsetWidth;
      root.classList.add('is-visible');
      // Body flag → m3x1.css sube la burbuja de Chatwoot arriba de la barra.
      document.body.classList.add('m3x1-sticky-on');
    }

    function hide() {
      if (root.hidden || hideTimer) return;
      root.classList.remove('is-visible');
      document.body.classList.remove('m3x1-sticky-on');
      // Wait out the transition before hiding (back out of tab order + a11y tree).
      hideTimer = window.setTimeout(function () {
        hideTimer = null;
        root.hidden = true;
      }, 220);
    }

    // Proxy a click to the REAL ATC button — runs the existing flow verbatim.
    // If the real button is disabled (sold out), do nothing.
    stickyBtn.addEventListener('click', function () {
      if (realAtcBtn.disabled || realAtcBtn.hasAttribute('disabled')) return;
      realAtcBtn.click();
    });

    if (typeof window.IntersectionObserver !== 'function') {
      // No IO support: leave the bar hidden (graceful, no crash).
      return;
    }

    // Dos señales (Mau 2026-07-05): PASADO el hero Y ANTES del newsletter del
    // footer. Al entrar el bloque "Suscríbete a nuestro newsletter" al
    // viewport, la barra se esconde para que el resto del footer (métodos de
    // pago, legales) se lea sin que el sticky lo tape.
    var pastHero = false;
    var footerInView = false;
    function syncSticky() {
      if (pastHero && !footerInView) {
        show();
      } else {
        hide();
      }
    }

    var observer = new window.IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          // Past-hero solo cuando el CTA ya scrolleó ARRIBA del viewport.
          // boundingClientRect.top < 0 distingue "ya lo pasé (arriba)" de
          // "aún no llego (below the fold, top positivo)".
          pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }
        syncSticky();
      },
      { threshold: 0 }
    );

    // Observe the hero ATC form: the sticky takes over once it leaves upward.
    observer.observe(form);

    // Observer del footer: target = el bloque del newsletter (mitad del
    // footer); fallback = la sección footer completa si el theme lo renombra.
    var footerTarget =
      document.querySelector('.footer-newsletter-block') ||
      document.getElementById('shopify-section-footer');
    if (footerTarget) {
      var footerObserver = new window.IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            footerInView = entries[i].isIntersecting;
          }
          syncSticky();
        },
        { threshold: 0 }
      );
      footerObserver.observe(footerTarget);
    }
  }

  function bootSticky() {
    var roots = document.querySelectorAll('[data-m3x1-sticky]');
    Array.prototype.forEach.call(roots, initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSticky);
  } else {
    bootSticky();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    var roots = target.querySelectorAll
      ? target.querySelectorAll('[data-m3x1-sticky]')
      : [];
    Array.prototype.forEach.call(roots, initSticky);
  });

  /* ============================================================
     Garantía Prioritaria Premium popup (Task 4.2) — low-ticket
     upsell shown when the shopper taps "Finalizar pedido" inside
     the Rebuy Smart Cart drawer, BEFORE we let them reach checkout.

     🔴 INVARIANT (separate from the ATC submit): this interceptor
     listens on the REBUY CHECKOUT BUTTON (.rebuy-cart__checkout-button),
     NOT on the ATC <form> submit. We NEVER stopPropagation on the ATC
     submit (that would kill pf-garantia). initAtc / initPopup are not
     touched. We NEVER navigate to /cart — "proceed" = re-click Rebuy's
     own button so Vue's checkout() runs.

     The Rebuy checkout button is Vue (binds click via addEventListener,
     no inline attr). A capture-phase listener on document fires BEFORE
     Vue. To BLOCK Vue: preventDefault + stopImmediatePropagation in
     capture (confirmed: stops navigation, no checkout). To PROCEED: set
     the m3x1GarantiaProceed guard, then btn.click() — our capture handler
     sees the guard, lets it pass, Vue's checkout() runs and navigates.

     ── Interceptor: block synchronously, THEN decide async ──────────────
     The capture handler MUST call preventDefault + stopImmediatePropagation
     SYNCHRONOUSLY (before any await) or Vue's bubble-phase checkout() will
     have already fired by the time a promise resolves. So we block first,
     then read /cart.js to decide whether to open the popup or proceed.
     ============================================================ */
  function initGarantiaPopup(root) {
    if (!root || root.dataset.m3x1GarantiaInit === '1') return;
    root.dataset.m3x1GarantiaInit = '1';

    var overlay = root.querySelector('[data-m3x1-garantia-overlay]');
    var dialog = root.querySelector('[data-m3x1-garantia-dialog]');
    var closeBtn = root.querySelector('[data-m3x1-garantia-close]');
    var acceptBtn = root.querySelector('[data-m3x1-garantia-accept]');
    var acceptLabel = root.querySelector('[data-m3x1-garantia-accept-label]');
    var declineBtn = root.querySelector('[data-m3x1-garantia-decline]');
    var errorEl = root.querySelector('[data-m3x1-garantia-error]');

    // Garantía variant id — read from the markup, NEVER hardcoded. This is
    // the SAME variant pf-garantia adds free; the interceptor's "already in
    // cart" check (below) uses it to avoid double-charge / double-offer.
    var variantId = parseInt(root.getAttribute('data-m3x1-garantia-variant'), 10);

    if (!dialog || !acceptBtn) return;

    var lastFocused = null;
    var keydownHandler = null;
    var submitting = false;

    function setLoading(on) {
      if (on) {
        acceptBtn.setAttribute('disabled', 'disabled');
        acceptBtn.setAttribute('aria-busy', 'true');
        acceptBtn.classList.add('is-loading');
        if (acceptLabel) {
          acceptLabel.textContent =
            acceptBtn.getAttribute('data-label-loading') || 'Agregando…';
        }
      } else {
        acceptBtn.removeAttribute('disabled');
        acceptBtn.removeAttribute('aria-busy');
        acceptBtn.classList.remove('is-loading');
        if (acceptLabel) {
          acceptLabel.textContent =
            acceptBtn.getAttribute('data-label-default') || acceptLabel.textContent;
        }
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent =
        msg || 'No se pudo agregar al carrito. Intenta de nuevo.';
    }

    function clearError() {
      if (errorEl) errorEl.textContent = '';
    }

    /* ---- Open / close (mirror of the color popup / zoom modal) ---- */
    // Timer del cierre en transición (race del audit 2026-07-04), espejo del
    // color popup: re-abrir dentro de los 200ms no debe quedar en blanco.
    var closeTimer = null;
    function open(trigger) {
      // Abierto DE VERDAD (sin cierre en transición) -> no re-abrir.
      if (!root.hidden && !closeTimer) return;
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      lastFocused = trigger || document.activeElement;
      clearError();

      root.hidden = false;
      // Force reflow so the CSS transition runs from the open state.
      void root.offsetWidth;
      root.classList.add('is-open');
      document.documentElement.classList.add('m3x1-zoom-lock');

      keydownHandler = onKeydown;
      document.addEventListener('keydown', keydownHandler, true);

      // Move focus into the dialog (close button is a safe first stop).
      (closeBtn || dialog).focus();
    }

    function close() {
      if (root.hidden || closeTimer) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('m3x1-zoom-lock');

      if (keydownHandler) {
        document.removeEventListener('keydown', keydownHandler, true);
        keydownHandler = null;
      }

      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        root.hidden = true;
      }, 200);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
      lastFocused = null;
    }

    // Close the modal, then continue to Rebuy's checkout. Used by X /
    // overlay / ESC / decline — per Mau, EVERY close path proceeds to
    // checkout; only "Asegurar" changes the outcome (adds the garantía).
    // There is NO "stay in cart" path from this popup.
    function closeAndProceed() {
      close();
      proceedToCheckout();
    }

    function trapFocus(e) {
      var focusables = Array.prototype.slice
        .call(dialog.querySelectorAll(FOCUSABLE))
        .filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      if (focusables.length === 0) {
        e.preventDefault();
        dialog.focus();
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || !dialog.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (active === last || !dialog.contains(active)) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        // ESC = a close path → mark offered + proceed to checkout.
        m3x1GarantiaOffered = true;
        closeAndProceed();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    }

    /* ---- Asegurar: add garantía variant, flag cart, then proceed ---- */
    function onAccept() {
      if (submitting) return;
      if (isNaN(variantId)) {
        // No resolvable variant — never block the sale; just continue.
        m3x1GarantiaOffered = true;
        closeAndProceed();
        return;
      }
      submitting = true;
      clearError();
      setLoading(true);

      window
        .fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: { _m3x1_garantia: 'auto' }
              }
            ]
          })
        })
        .then(function (res) {
          if (!res.ok) {
            return res
              .json()
              .catch(function () {
                return null;
              })
              .then(function (body) {
                var msg = body && body.description ? body.description : null;
                throw new Error(msg || 'cart_add_failed');
              });
          }
          return res.json();
        })
        .then(function () {
          // Tag the cart so the order tag (Flow) knows the garantía came
          // from THIS popup (vs protocolofacial). Best-effort: a failed
          // attribute write must not abort the checkout the shopper asked
          // for, so we proceed regardless of this call's outcome.
          return window
            .fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ attributes: { _garantia_via: 'popup' } })
            })
            .catch(function () {
              /* swallow — the garantía is already in the cart */
            });
        })
        .then(function () {
          dispatchCartRefresh();
          setLoading(false);
          submitting = false;
          m3x1GarantiaOffered = true;
          closeAndProceed();
        })
        .catch(function (err) {
          // Add failed: restore the button, show the error, keep the popup
          // open to retry. NEVER proceed / navigate on a failed add.
          setLoading(false);
          submitting = false;
          showError(
            err && err.message && err.message !== 'cart_add_failed'
              ? err.message
              : null
          );
        });
    }

    // Expose open() so the capture interceptor can trigger it by reference.
    root.m3x1GarantiaOpen = open;

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        m3x1GarantiaOffered = true;
        closeAndProceed();
      });
    }
    if (overlay) {
      overlay.addEventListener('click', function () {
        m3x1GarantiaOffered = true;
        closeAndProceed();
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        m3x1GarantiaOffered = true;
        closeAndProceed();
      });
    }
    acceptBtn.addEventListener('click', onAccept);
  }

  /* Proceed to checkout = re-click Rebuy's own button so Vue's checkout()
     runs. The m3x1GarantiaProceed guard makes the capture interceptor let
     this synthetic click pass through. We NEVER navigate to /cart. */
  function proceedToCheckout() {
    m3x1GarantiaProceed = true;
    var btn = document.querySelector('.rebuy-cart__checkout-button');
    if (btn) btn.click();
    m3x1GarantiaProceed = false;
  }

  /* Capture-phase interceptor on Rebuy's checkout button. Block FIRST
     (synchronously), then decide async whether to open the popup. */
  function onCheckoutClickCapture(e) {
    var btn =
      e.target && e.target.closest
        ? e.target.closest('.rebuy-cart__checkout-button')
        : null;
    if (!btn) return;

    // Our own re-click (proceedToCheckout) — let it through to Vue.
    if (m3x1GarantiaProceed) return;

    // Already offered + resolved this session — don't nag, let checkout run.
    if (m3x1GarantiaOffered) return;

    // BLOCK Vue's checkout() synchronously, before any await. Do the
    // /cart.js inspection only AFTER the synchronous block.
    e.preventDefault();
    e.stopImmediatePropagation();

    var root = document.querySelector('[data-m3x1-garantia-popup]');
    if (!root) {
      // No popup in the DOM (e.g. garantía variant didn't resolve) — never
      // block the sale; mark offered and proceed straight to checkout.
      m3x1GarantiaOffered = true;
      proceedToCheckout();
      return;
    }

    var variantId = parseInt(root.getAttribute('data-m3x1-garantia-variant'), 10);

    // Abre el popup SOLO si terminó de inicializar; si el root existe pero
    // init falló (markup alterado/incompleto), NUNCA bloquear la venta:
    // marcar ofrecido y pasar directo al checkout. Sin este guard, cada clic
    // de "Finalizar pedido" se cancelaba y tronaba (TypeError doble, sin
    // catch) = checkout bloqueado + script errors (audit 2026-07-04).
    var openPopupOrProceed = function () {
      if (typeof root.m3x1GarantiaOpen === 'function') {
        root.m3x1GarantiaOpen(btn);
      } else {
        m3x1GarantiaOffered = true;
        proceedToCheckout();
      }
    };

    window
      .fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        // If the garantía variant is already a line item (pf-garantia /
        // protocolofacial added it free), don't double-offer — proceed.
        var already = false;
        if (cart && cart.items && !isNaN(variantId)) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i] && cart.items[i].variant_id === variantId) {
              already = true;
              break;
            }
          }
        }
        if (already) {
          m3x1GarantiaOffered = true;
          proceedToCheckout();
          return;
        }
        // Fresh offer: open the popup (pass btn for restore-focus on close).
        openPopupOrProceed();
      })
      .catch(function () {
        // /cart.js unreadable — never strand the shopper at the drawer.
        // Open the popup anyway (the accept add still de-dupes server-side
        // via the cart; worst case Mau's "already in cart" never triggers).
        openPopupOrProceed();
      });
  }

  function bootGarantia() {
    var roots = document.querySelectorAll('[data-m3x1-garantia-popup]');
    Array.prototype.forEach.call(roots, initGarantiaPopup);

    // Install the capture-phase interceptor exactly once.
    if (!m3x1GarantiaInterceptorBound) {
      document.addEventListener('click', onCheckoutClickCapture, true);
      m3x1GarantiaInterceptorBound = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootGarantia);
  } else {
    bootGarantia();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    var roots = target.querySelectorAll
      ? target.querySelectorAll('[data-m3x1-garantia-popup]')
      : [];
    Array.prototype.forEach.call(roots, initGarantiaPopup);
    // Re-installs the interceptor if a prior unload removed it.
    if (!m3x1GarantiaInterceptorBound) {
      document.addEventListener('click', onCheckoutClickCapture, true);
      m3x1GarantiaInterceptorBound = true;
    }
  });

  // Editor re-renders: drop the capture listener so it doesn't accumulate
  // across section unload/load cycles (bootGarantia re-installs on load).
  document.addEventListener('shopify:section:unload', function () {
    if (m3x1GarantiaInterceptorBound) {
      document.removeEventListener('click', onCheckoutClickCapture, true);
      m3x1GarantiaInterceptorBound = false;
    }
  });

  /* ============================================================
     Gel guard (Mau 2026-07-02, supersede el "gel clamp" 2026-06-22) —
     el gel automático (variant 46874616955115) es el gel baked del 3x1.
     En cada cambio de carrito, con los datos de /cart.js:

       1. AUTO-REMOVE: si hay gel pero CERO devices sueltos (handles
          skindion-rosa / skindion-negro), se quitan TODAS las líneas de
          gel. Cierra el exploit "quito los 3 Skindions, dejo el gel,
          re-agrego -> 2 geles". El Kit Spa Facial NO cuenta como device
          (Mau: el kit nunca lleva gel automático).
       2. CLAMP: qty por línea nunca > MAX (2). (Se conserva del clamp
          viejo; el plan cobra $549 POR UNIDAD.)
       3. UNLOCK del EXTRA: si aun así quedan >=2 geles (carritos viejos,
          doble 3x1), el cliente SÍ puede quitar el 2º: la línea que NO
          es la canónica (la canónica = la que trae la propiedad
          "Renovación ... (pausa ...") recibe .m3x1-gel-extra -> su X
          reaparece (el <style> de lock usa :not(.m3x1-gel-extra)). Si es
          UNA sola línea con qty 2, recibe .m3x1-gel-multi -> reaparece el
          stepper para bajar a 1 (a qty 1 el guard re-esconde el stepper,
          así no llegan a 0). Rebuy re-renderiza (Vue) y borra las clases
          -> se re-aplican vía MutationObserver debounced.

     NO corre mientras onContinue agrega gel+devices (m3x1GelAddInFlight):
     el gel entra ANTES que los devices y el guard lo borraría a media
     venta. Guard anti-loop + debounce; nunca toca otros productos ni
     debe romper el carrito. SCOPE: donde carga m3x1.js (el PDP 3x1).
     ============================================================ */
  (function initGelGuard() {
    var GEL_VARIANT = 46874616955115;
    var DEVICE_HANDLES = ['skindion-rosa', 'skindion-negro'];
    var GEL_LI_SEL =
      '.rebuy-cart__flyout-item.product-gel-regenerativo-200g-dark-page-product';
    var MAX = 2; // máx 2 geles auto (Mau 2026-06-23; el plan cobra $549 POR UNIDAD)
    var busy = false;
    var timer = null;
    // Último estado conocido del gel en /cart.js — lo usa applyClasses (que
    // corre en mutaciones del DOM, sin re-fetch).
    var gelState = { total: 0, lines: 0 };

    function applyClasses() {
      var lis = document.querySelectorAll(GEL_LI_SEL);
      if (!lis.length) return;
      // Canónica = la línea con la propiedad visible "Renovación ... (pausa..."
      // (el gel baked del flujo). Si ninguna la trae, la ÚLTIMA del DOM
      // (Rebuy pinta newest-first -> la de abajo es la más vieja = la original).
      var canonical = null;
      for (var i = 0; i < lis.length; i++) {
        var pv = lis[i].querySelector('.rebuy-cart__flyout-item-property-value');
        if (pv && (pv.textContent || '').indexOf('(pausa') !== -1) {
          canonical = lis[i];
          break;
        }
      }
      if (!canonical) canonical = lis[lis.length - 1];
      var multi = gelState.total >= 2;
      Array.prototype.forEach.call(lis, function (li) {
        // X visible solo en las líneas NO canónicas cuando hay gel de sobra.
        li.classList.toggle('m3x1-gel-extra', multi && lis.length > 1 && li !== canonical);
        // Stepper visible solo si UNA línea concentra los 2 (para bajar a 1).
        li.classList.toggle('m3x1-gel-multi', multi && lis.length === 1);
      });
    }

    function enforceNow() {
      if (busy) return;
      if (m3x1GelAddInFlight) return; // onContinue re-dispara los eventos al terminar
      busy = true;
      window
        .fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var gelLines = items.filter(function (i) {
            return i.variant_id === GEL_VARIANT;
          });
          var devicesQty = 0;
          items.forEach(function (i) {
            if (DEVICE_HANDLES.indexOf(i.handle) !== -1) devicesQty += i.quantity;
          });
          gelState.lines = gelLines.length;
          gelState.total = gelLines.reduce(function (s, i) {
            return s + i.quantity;
          }, 0);

          // (1) Sin devices sueltos -> el gel automático se va completo.
          if (gelLines.length && devicesQty === 0) {
            gelState.lines = 0;
            gelState.total = 0;
            return gelLines
              .reduce(function (p, line) {
                return p.then(function () {
                  // /cart/change.js usa line.key (clave única que incluye
                  // selling_plan y properties de la línea del gel).
                  return window.fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ id: line.key, quantity: 0 })
                  });
                });
              }, Promise.resolve())
              .then(function () {
                dispatchCartRefresh(); // refresca el drawer de Rebuy
              });
          }

          // (2) Clamp qty > MAX (una línea a la vez; el refresh re-dispara
          // el guard y barre las siguientes si hubiera más).
          var over = gelLines.filter(function (i) {
            return i.quantity > MAX;
          });
          if (over.length) {
            gelState.total -= over[0].quantity - MAX;
            return window
              .fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: over[0].key, quantity: MAX })
              })
              .then(function () {
                dispatchCartRefresh();
              });
          }
          return null;
        })
        .catch(function () {
          /* el guard nunca debe romper el carrito */
        })
        .then(function () {
          busy = false;
          applyClasses(); // (3) sincroniza las clases de unlock con el estado
        });
    }

    function schedule() {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(enforceNow, 250); // debounce
    }

    // Rebuy dispara rebuy:cart.change al cambiar el carrito (incl. X y stepper
    // del drawer). Escuchamos varios alias por robustez.
    ['rebuy:cart.change', 'rebuy:cart.update', 'cart:updated', 'cart:refresh'].forEach(
      function (ev) {
        document.addEventListener(ev, schedule);
      }
    );

    // Rebuy re-renderiza sus <li> (Vue) y borra nuestras clases -> re-aplicar
    // en cada mutación (debounced, sin re-fetch; usa el último gelState).
    var applyTimer = null;
    function scheduleApply() {
      if (applyTimer) window.clearTimeout(applyTimer);
      applyTimer = window.setTimeout(applyClasses, 150);
    }
    try {
      new MutationObserver(scheduleApply).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (e) {
      /* sin MutationObserver quedan los eventos de carrito de arriba */
    }

    schedule(); // chequeo inicial (carritos que ya traen el estado malo)
  })();

  /* ============================================================
     Cupón aplicado visible en el drawer (Mau 2026-07-05, "Opción B"
     aprobada por preview) — cuando el carrito trae un DISCOUNT CODE
     aplicado (p.ej. FLASH100 vía /discount/CODE?redirect=...), se
     inyecta una línea arriba del subtotal de Rebuy: ícono de etiqueta
     rosa + "Cupón <CODE> aplicado" (pill) + "−$X" en verde. Confirma
     a quien llegó por el link del flash sale que su descuento YA está.

     - GENÉRICO: lee cart.cart_level_discount_applications de /cart.js
       y muestra solo type === 'discount_code' con monto > 0 (los
       descuentos AUTOMÁTICOS como el BXGY "3x1 Mudanza" viven a nivel
       línea o son type distinto — NO se anuncian como cupón).
     - Sin cupón => la línea no existe (y se remueve si el código se
       cae del carrito).
     - Rebuy re-renderiza su flyout (Vue) y borra el nodo => se
       re-inyecta vía MutationObserver (sin re-fetch; usa el último
       estado) + refresh (con fetch) en los eventos de carrito.
     - SCOPE: donde carga m3x1.js (el PDP 3x1 = el funnel real).
     ============================================================ */
  (function initCartCoupon() {
    var state = null; // { code, amount(cents) } | null
    var TAG_SVG =
      '<svg class="m3x1-cart-coupon__icon" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<path d="M20.59 13.41 11 3.82A2 2 0 0 0 9.59 3.23H5a2 2 0 0 0-2 2v4.59c0 .53.21 1.04.59 1.41l9.58 9.59a2 2 0 0 0 2.83 0l4.59-4.59a2 2 0 0 0 0-2.82z"/>' +
      '<circle cx="7.5" cy="7.5" r="1"/></svg>';

    function inject() {
      var existing = document.querySelector('[data-m3x1-cart-coupon]');
      if (!state) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      var subtotal = document.querySelector('.rebuy-cart__flyout-subtotal');
      if (!subtotal || !subtotal.parentNode) return;
      // Ya está puesto, actualizado y en su lugar -> no tocar el DOM
      // (evita loop con el MutationObserver).
      if (
        existing &&
        existing.getAttribute('data-code') === state.code &&
        existing.getAttribute('data-amt') === String(state.amount) &&
        existing.parentNode === subtotal.parentNode
      ) {
        return;
      }
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

      var row = document.createElement('div');
      row.className = 'm3x1-cart-coupon';
      row.setAttribute('data-m3x1-cart-coupon', '');
      row.setAttribute('data-code', state.code);
      row.setAttribute('data-amt', String(state.amount));
      row.innerHTML =
        TAG_SVG +
        '<span class="m3x1-cart-coupon__label">Cupón <span class="m3x1-cart-coupon__code"></span> aplicado</span>' +
        '<span class="m3x1-cart-coupon__amt"></span>';
      // textContent (no innerHTML) para el código y el monto: datos externos.
      row.querySelector('.m3x1-cart-coupon__code').textContent = state.code;
      row.querySelector('.m3x1-cart-coupon__amt').textContent =
        '−$' + Math.round(state.amount / 100).toLocaleString('es-MX');
      subtotal.parentNode.insertBefore(row, subtotal);
    }

    function refresh() {
      window
        .fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var apps = (cart && cart.cart_level_discount_applications) || [];
          var codeApp = null;
          for (var i = 0; i < apps.length; i++) {
            if (
              apps[i] &&
              apps[i].type === 'discount_code' &&
              Number(apps[i].total_allocated_amount) > 0
            ) {
              codeApp = apps[i];
              break;
            }
          }
          state = codeApp
            ? {
                code: String(codeApp.title || codeApp.key || 'DESCUENTO'),
                amount: Number(codeApp.total_allocated_amount)
              }
            : null;
          inject();
        })
        .catch(function () {
          /* el aviso del cupón nunca debe romper el carrito */
        });
    }

    var t = null;
    function schedule() {
      if (t) window.clearTimeout(t);
      t = window.setTimeout(refresh, 200);
    }
    ['rebuy:cart.change', 'rebuy:cart.update', 'cart:updated', 'cart:refresh', 'rebuy:smartcart.ready'].forEach(
      function (ev) {
        document.addEventListener(ev, schedule);
      }
    );
    // Rebuy re-pinta el flyout y borra el nodo -> re-inyectar (sin fetch).
    var mt = null;
    function mSchedule() {
      if (mt) window.clearTimeout(mt);
      mt = window.setTimeout(inject, 150);
    }
    try {
      new MutationObserver(mSchedule).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (e) {
      /* sin MutationObserver quedan los eventos de carrito */
    }
    schedule(); // estado inicial (p.ej. llegó con el cupón ya en cookie)
  })();

  /* ============================================================
     Bold parcial de la línea "Renovación" del gel — SOLO en el carrito
     (Mau 2026-06-24). El VALOR de la propiedad se guarda en TEXTO PLANO
     porque el checkout NATIVO de Shopify ESCAPA el HTML de las line-item
     properties (con <strong> en el valor, el checkout mostraba el tag
     literal "<strong>...</strong>"). Así que aquí, SOLO en el drawer de
     Rebuy, envolvemos en <strong> todo el valor MENOS "(pausa o cancela
     ...)". Rebuy re-renderiza sus líneas (Vue via v-html) y borra nuestra
     envoltura, por eso re-aplicamos en cada mutación del DOM (MutationObserver
     debounced) + en los eventos de carrito de Rebuy. Idempotente: si el span
     ya tiene <strong>, no re-hace -> sin loop. El checkout queda intacto y
     limpio (texto plano). ============================================================ */
  (function initGelPropBold() {
    var SEL =
      '.rebuy-cart__flyout-item.product-gel-regenerativo-200g-dark-page-product .rebuy-cart__flyout-item-property-value';
    var SPLIT = ' (pausa'; // todo lo anterior a esto va en <strong>
    var t = null;
    function apply() {
      var spans = document.querySelectorAll(SEL);
      Array.prototype.forEach.call(spans, function (span) {
        if (span.querySelector('strong')) return; // ya aplicado
        var full = span.textContent || '';
        var idx = full.indexOf(SPLIT);
        if (idx <= 0) return; // sin la parte "(pausa..." -> no tocar
        var strong = document.createElement('strong');
        strong.textContent = full.slice(0, idx);
        span.textContent = '';
        span.appendChild(strong);
        span.appendChild(document.createTextNode(full.slice(idx)));
      });
    }
    function schedule() {
      if (t) clearTimeout(t);
      t = setTimeout(apply, 150);
    }
    try {
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (e) {
      /* sin MutationObserver: nos quedan los eventos de abajo */
    }
    ['rebuy:cart.change', 'rebuy:cart.update', 'cart:updated', 'cart:refresh'].forEach(
      function (ev) {
        document.addEventListener(ev, schedule);
      }
    );
    schedule();
  })();

  // ── Fecha de entrega dinamica bajo "Envio gratis" ─────────────────────────
  // Rellena "Llega el 16-20 Julio" en la linea de envio del buybox. La ventana
  // (min/max dias) llega en data-attrs del span (default 2 y 6, = el ejemplo de
  // Mau: hoy 14 -> 16-20). Se calcula en horario de Mexico (America/Mexico_City)
  // para no desfasar a visitantes fuera de MX. El span va `hidden` en el markup y
  // se muestra solo cuando el rango se pinta (si algo falla queda oculto = degrada
  // a "Envio gratis a todo Mexico" a secas). Corre en cada carga (fecha siempre al dia).
  (function initShippingEta() {
    var MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
                 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    // "Hoy" segun el calendario de Ciudad de Mexico, como Date a medianoche local
    // (solo se usa para extraer dia/mes, la TZ de construccion es irrelevante).
    function hoyMx() {
      try {
        var p = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Mexico_City',
          year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date());
        var y, m, d;
        p.forEach(function (x) {
          if (x.type === 'year') y = parseInt(x.value, 10);
          if (x.type === 'month') m = parseInt(x.value, 10);
          if (x.type === 'day') d = parseInt(x.value, 10);
        });
        if (y && m && d) return new Date(y, m - 1, d);
      } catch (e) {}
      return new Date(); // fallback: hora local del visitante
    }

    function rango(minDias, maxDias) {
      var base = hoyMx();
      var ini = new Date(base); ini.setDate(ini.getDate() + minDias);
      var fin = new Date(base); fin.setDate(fin.getDate() + maxDias);
      var di = ini.getDate(), mi = ini.getMonth();
      var df = fin.getDate(), mf = fin.getMonth();
      if (mi === mf) {
        return di + '–' + df + ' ' + MESES[mf];                     // "16-20 Julio"
      }
      return di + ' ' + MESES[mi] + ' – ' + df + ' ' + MESES[mf];   // "30 Julio - 3 Agosto"
    }

    function apply() {
      var els = document.querySelectorAll('[data-m3x1-eta]');
      if (!els.length) return;
      Array.prototype.forEach.call(els, function (el) {
        var min = parseInt(el.getAttribute('data-eta-min'), 10);
        var max = parseInt(el.getAttribute('data-eta-max'), 10);
        if (isNaN(min)) min = 2;
        if (isNaN(max)) max = 6;
        var out = el.querySelector('[data-m3x1-eta-range]');
        if (!out) return;
        try {
          out.textContent = rango(min, max);
          el.hidden = false;
        } catch (e) { /* deja el span oculto si algo truena */ }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply);
    } else {
      apply();
    }
  })();
})();
